import { GetLodgingRequestsAllCountState, GetLodgingRequestsAllCountActionTypes, GET_LODGING_REQUESTS_ALL_COUNT_DATA_REQUEST, GET_LODGING_REQUESTS_ALL_COUNT_DATA_SUCCESS, GET_LODGING_REQUESTS_ALL_COUNT_DATA_FAILURE } from "store/reducers/lodgingRequest/get-all-count/types";

const defaultState: GetLodgingRequestsAllCountState = {
  isLoading: false,
  errorMessage: "",
  contents: 0
};

export default function getAllCount(state = defaultState, action: GetLodgingRequestsAllCountActionTypes): GetLodgingRequestsAllCountState {
  switch (action.type) {
    case GET_LODGING_REQUESTS_ALL_COUNT_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_LODGING_REQUESTS_ALL_COUNT_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_LODGING_REQUESTS_ALL_COUNT_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};